import SectionDetail from './SectionDetail';

export default SectionDetail;
